import React, { useEffect, useState } from 'react';
import Input from '../Inputs/Input';
import { translate } from '../../Services/translation';
import LoadingSpinner from '../LoadingSpinner';

interface ImageRepositorySearchProps {
  onSearch: (text: string) => void;
  value?: string;
  isLoading: boolean;
}

const ImageRepositorySearch = ({
  onSearch,
  value,
  isLoading,
}: ImageRepositorySearchProps) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (ready) {
      document.getElementById('image-repository-search')?.focus();
    }
  }, [ready]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      onSearch(e.target.value); // TODO debounce
    }
  };

  return (
    <div className="w-full">
      <Input
        id="image-repository-search"
        onChange={onChange}
        defaultValue={value}
        placeholder={translate('general.search')}
        disabled={!ready}
        autoFocus={ready}
        icon={
          isLoading ? (
            <div className="icon">
              <LoadingSpinner
                className="spin h-5 w-5"
                includeBaseClasses={false}
              />
            </div>
          ) : undefined
        }
      />
    </div>
  );
};

export default ImageRepositorySearch;
